module.exports = __webpack_public_path__ + "Inter-Black.woff2?95d8d7e7efaa8fe5af55c14636172c1f";


//////////////////
// WEBPACK FOOTER
// ./src/assets/font/Inter-woff2/Inter-Black.woff2
// module id = 529
// module chunks = 289